module.exports = __webpack_public_path__ + "files/2e9cbde3d939844257e1acd37730cce5.png";